import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// City - Get All (Read)
export const GetAllIntrestHistory = createAsyncThunk(
  "admin/wallet/intrest-history",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Wallet.intrest_history}?name=${filter?.name || ""}&from=${
          filter?.from || ""
        }&to=${filter?.to || ""}&page=${filter?.page || IDS.PAGE}&per_page=${
          filter?.per_page || IDS.PERPAGE
        }`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// City - Get (Read)
export const GetIntrestHistory = createAsyncThunk(
  "admin/wallet/intrest-history/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Wallet.intrest_history}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// City - Create (Add)
export const AddIntrestHistory = createAsyncThunk(
  "admin/wallet/intrest-history/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Wallet.intrest_history, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// City - Update
export const UpdateIntrestHistory = createAsyncThunk(
  "admin/wallet/intrest-history/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Wallet.intrest_history}/${id}`, {
        name: data.name,
        country_id: data.country_id,
        state_id: data.state_id,
      });
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// City - Delete
export const DeleteIntrestHistory = createAsyncThunk(
  "admin/wallet/intrest-history/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Wallet.intrest_history}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// City - Status
export const StatusIntrestHistory = createAsyncThunk(
  "admin/wallet/intrest-history/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Wallet.intrest_history}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "city",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllIntrestHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllIntrestHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllIntrestHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetIntrestHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetIntrestHistory.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetIntrestHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AddIntrestHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddIntrestHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddIntrestHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdateIntrestHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateIntrestHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (city) => city.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdateIntrestHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(DeleteIntrestHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteIntrestHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter((city) => city.id !== action.payload);
      })
      .addCase(DeleteIntrestHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(StatusIntrestHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusIntrestHistory.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(StatusIntrestHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
